type Procedure = (...args: any[]) => void; // eslint-disable-line @typescript-eslint/no-explicit-any

function debounce<F extends Procedure>(func: F, wait = 300, immediate = true): (...args: Parameters<F>) => void {
    let timeout: ReturnType<typeof setTimeout> | null | undefined;

    return (...args: Parameters<F>) => {
        const callNow = immediate && !timeout;

        if (timeout) clearTimeout(timeout);

        timeout = setTimeout(() => {
            if (timeout) timeout = null;

            if (!immediate) func.apply(null, args); // eslint-disable-line prefer-spread
        }, wait);

        if (callNow) {
            func.apply(null, args); // eslint-disable-line prefer-spread
        }
    };
}

export { debounce };
